<div class="" style=" text-align:center;  ">

  <div class="row" style="">
    <div class="col-lg-12 col-sm-12" style="{{appDesignHP.content_text_style}}">
      <div style=" padding: 10px 5px 10px 5px; text-align: left; " *ngIf="isClientPage"> {{appDesignHP.app_description}}
      </div>
      <div class="col-lg-12 col-sm-12" style=" padding: 10px 5px 10px 5px; text-align: left; " *ngIf="!isClientPage">
        {{appBundlesHP.bundle_description}}
      </div>
      <div class="col-lg-12 col-sm-12" style=" color: red; padding: 10px 5px 10px 5px; text-align: left; "
        *ngIf="!isClientPage">
        Bundle Price: <b> ${{appBundlesHP.bundle_price}}</b>
      </div>
    </div>
  </div>
  <div class="row" style="padding-top: 20px;" *ngIf="isClientPage">
    <div class="col-lg-12 col-sm-12" style="{{appDesignHP.bundle_list_title_style}}">
      <div style=" padding: 20px;  ">{{appDetailsHP.appName}} Bundles
      </div>
    </div>
  </div>
  <div class="row" style="padding-top: 5px; text-align: center; {{appDesignHP.bundle_list_background_style}}"
    *ngIf="isClientPage">
    <div *ngFor="let bundles of this.appBundlesHP;" class="col-lg-12 col-sm-12 "
      style="text-align: center;  float: left;  ">
      <div class="col-lg-3 col-sm-12 bundle_center" style="text-align: center;  float: left;">

        <img style="border-radius:3px; height: 150px;  box-shadow: 0 0 10px rgb(8, 8, 8);"
          src="{{bundles.bundle_logo}}">

        <div>
          <a href="https://{{this.siteDomainHP}}-sm.swigit.com/bundle/{{bundles.bundle_permalink}}"
            style="{{appDesignHP.bundle_name_style}}" target="_blank">{{bundles.bundle_name}}</a>

        </div>
        <div style=" padding: 10px 5px 10px 5px; color: red; ">
          Bundle Price: <b>${{bundles.bundle_price}}</b>
        </div>
        <button class="pt-2 pb-2 text-right login cursor-pointer" style="background-color: #a42310; border: none;"
          (click)="finalpay(bundles.bundle_price)">
          <!-- <i class="fa fa-sign-in" aria-hidden="true"></i> -->
          <span class="hidden-sm p-3" style="color: white"> Click to Buy</span>
        </button>
      </div>



    </div>
  </div>
  <div class="row" style="text-align: center; height: 20px; {{appDesignHP.bundle_list_background_style}}"></div>
  <div class="row" style="">
    <div class="col-lg-12 col-sm-12"
      style="border: 1px rgb(197, 197, 197) solid; {{appDesignHP.swigit_list_title_style}}">
      <div style=" padding: 20px;  " *ngIf="isClientPage">{{appDetailsHP.appName}} Swigits
      </div>
      <div style=" padding: 20px;  " *ngIf="!isClientPage">{{appBundlesHP.bundle_name}} Swigits
      </div>
    </div>
  </div>
  <div class="row" style="text-align: center; {{appDesignHP.swigit_list_background_style}}" *ngIf="isClientPage">
    <div *ngFor="let swigitArr of this.swigitsHP;" class="col-lg-12 col-sm-12"
      style="text-align: center;  padding: 0px !important; ">
      <div class="col-lg-12 col-sm-12" style="text-align: center;  {{appDesignHP.swigit_menu_style}}">
        {{swigitArr.menu_name}}</div>
      <div *ngFor="let swigitStreamArr of swigitArr.streams;" class="bundle_center" style="text-align: center; 
            border: 1px rgb(197, 197, 197) solid ">


        <div class="row">
          <div class="col-lg-2 col-sm-12 " style="text-align: center; float: left;">
            <img style="border-radius: 4px 4px 0px 0px; width: 200px; box-shadow: 0 0 10px rgb(8, 8, 8); "
              src="{{swigitStreamArr.stream_poster}}"><br>
            <button style="border-radius: 0px 0px 4px 4px;width: 200px; padding-top: 5px; padding-bottom: 5px; 
             {{appDesignHP.swigit_promo_button_style}}"
              (click)="onPromoBtnClick(swigitStreamArr.stream_url)">Promo</button>

          </div>
          <div class="col-lg-10 col-sm-12 " style="float: left; text-align: left;">

            <a href="https://{{this.siteDomainHP}}.swigit.com/app/{{swigitStreamArr.stream_permalink}}"
              style=" padding-bottom: 5px;{{appDesignHP.swigit_name_style}}"
              target="_blank">{{swigitStreamArr.stream_title}}</a><br>


            {{swigitStreamArr.stream_description}}<bR>
            <a href="https://{{this.siteDomainHP}}.swigit.com/app/{{swigitStreamArr.stream_permalink}}"
              style=" padding-bottom: 5px; text-decoration: underline; color: brown;" target="_blank">More
              Details...</a>
          </div>

        </div>
      </div>


    </div>
  </div>
  <div class="row" style="text-align: center; {{appDesignHP.swigit_list_background_style}}" *ngIf="!isClientPage">


    <div *ngFor="let swigitStreamArr of swigitsHP.streams;" class="col-lg-12 col-sm-12"
      style="text-align: center;  border: 1px rgb(197, 197, 197) solid ">


      <div class="row">
        <div class="col-lg-2 col-sm-12 bundle_center" style="text-align: center; float: left;">
          <img style="border-radius: 4px 4px 0px 0px; width: 200px; box-shadow: 0 0 10px rgb(8, 8, 8); "
            src="{{swigitStreamArr.stream_poster}}"><br>
          <button style="border-radius: 0px 0px 4px 4px;width: 200px; padding-top: 5px; padding-bottom: 5px; 
         {{appDesignHP.swigit_promo_button_style}}"
            (click)="onPromoBtnClick(swigitStreamArr.stream_url)">Promo</button>

        </div>
        <div class="col-lg-10 col-sm-12 " style="float: left; text-align: left;">

          <a href="https://{{this.siteDomainHP}}.swigit.com/app/{{swigitStreamArr.stream_permalink}}"
            style=" padding-bottom: 5px;{{appDesignHP.swigit_name_style}}"
            target="_blank">{{swigitStreamArr.stream_title}}</a><br>


          {{swigitStreamArr.stream_description}}<br>
          <a href="https://{{this.siteDomainHP}}.swigit.com/app/{{swigitStreamArr.stream_permalink}}"
            style=" padding-bottom: 5px; text-decoration: underline; color: brown;" target="_blank">More Details...</a>
          <br>
          <a href="https://{{this.siteDomainHP}}.swigit.com/app/{{swigitStreamArr.stream_permalink}}"
            style=" padding-bottom: 5px; text-decoration: underline; color: brown;" target="_blank">
            <button class="mt-3 pt-2 pb-2 text-right login cursor-pointer"
              style="background-color: #a42310; border: none;">
              <!-- <i class="fa fa-sign-in" aria-hidden="true"></i> -->
              <span class="hidden-sm p-3" style="color: white"> Click to Buy </span>
            </button>
          </a>

        </div>

      </div>
    </div>



  </div>



</div>